console.log('HELOO WORLD', $)
/** TOOLS START **/
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

$(document).ready(function () {
  console.log("BEGIN");
  var extra;
  var b64_params = getUrlParameter("params");
  var b64_extra = getUrlParameter("extra");
  const blob = window.atob(b64_params);
  const jsonString = blob.replace(/[^\x20-\x7E]/g, '');
  var params = JSON.parse(jsonString);

  if (b64_extra && b64_extra !== "") {
    try {
      extra = JSON.parse(window.atob(b64_extra));
    } catch (err) {
      console.log(err);
    }
  }

  var url = params.imageUrl;
  var selection = {
    x1: params.x1,
    x2: params.x2,
    y1: params.y1,
    y2: params.y2,
  };
  selection.width = selection.x2 - selection.x1;
  selection.height = selection.y2 - selection.y1;

  function preview(selection) {
    if (!selection.width || !selection.height) return;
    var scaleX = 150 / selection.width;
    var scaleY = 150 / selection.height;

    $("#preview").css({
      width: Math.round(scaleX * $("#croptarget").width()) + "px",
      height: Math.round(scaleY * $("#croptarget").height()) + "px",
      marginLeft: -Math.round(scaleX * selection.x1),
      marginTop: -Math.round(scaleY * selection.y1),
    });
    $("#preview").hide();
    $("#cover").hide();
  }

  $("#croptarget")
    .on("load", function () {
      $("#croptarget").css({
        width: params.width + "px",
        height: params.height + "px",
      });
      if (extra && Array.isArray(extra)) {
        for (var i = 0; i < extra.length; i++) {
          var img_url = extra[i].url;
          $("#images_container").prepend(
            "<img alt='' src='" +
              img_url +
              "' class='center-fit' style='position: absolute;object-fit: contain;height: 100%;width: 100%'>"
          );
        }
      }
      $("#croptarget").imgAreaSelect({
        movable: false,
        persistent: true,
        resizable: false,
        width: 300,
        height: 400,
        x1: selection.x1,
        y1: selection.y1,
        x2: selection.x2,
        y2: selection.y2,
      });
      preview(selection);
    })
    .attr("src", url);

  /** TOOLS END **/
});
